import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
import { isMobile } from "../../configs/utils";
const _isMobile = isMobile();
export const OtpDS = (phone_number, refCode, referredPartner) => {
    const DS = {
        otpComponentContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: true,
            maxWidth: _isMobile ? '100%' : 400,
            bgColor: ColorTokens.White,
            borderConfig: {
                borderColor: ColorTokens.Primary_10,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: _isMobile ? {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            } : {
                left: SizeTypeTokens.Size32,
                right: SizeTypeTokens.Size32,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'title', type: WIDGET.TEXT },
                { id: 'space1', type: WIDGET.SPACE },
                { id: 'subTitleStack', type: WIDGET.STACK },
                { id: 'space2', type: WIDGET.SPACE },
                { id: 'input', type: WIDGET.INPUT },
            ],
        },
        title: {
            label: 'Enter OTP',
            fontSize: FontSizeTokens.XL,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
        },
        subTitleStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                { id: 'subTitle', type: WIDGET.TEXT },
                { id: 'subTitle2', type: WIDGET.TEXT },
                { id: 'editNumber', type: WIDGET.TEXT },
            ],
            action: {
                type: ACTION.GO_TO_PHONE_NUMBER_ACTION,
                payload: {},
                routeId: ROUTE.PARTNER_SIGNUP,
            },
        },
        subTitle: {
            label: `We’ve sent an OTP to `,
            color: ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
        },
        subTitle2: {
            label: ``,
            color: ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
        },
        editNumber: {
            label: `   Edit`,
            color: ColorTokens.Primary_100,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            paddingLeft: 6,
            paddingRight: 6,
        },
        input: {
            isFocus: true,
            title: 'Enter OTP',
            type: InputTypeToken.OTP,
            state: InputStateToken.DEFAULT,
            keyboardType: KeyboardTypeToken.numberPad,
            charLimit: 4,
            action: {
                type: ACTION.VERIFY_OTP,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: "",
                    widgetId: "input",
                    refCode: refCode,
                    referredPartner: referredPartner
                },
            },
            otpAction: {
                type: ACTION.RE_SEND_OTP,
                payload: {
                    value: ``,
                    widgetId: "input",
                    isResend: true,
                    referredPartner: referredPartner
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
        },
        space1: { size: SizeTypeTokens.SM },
        space2: { size: SizeTypeTokens.XXXL },
    };
    return DS;
};
